import styled from "@rentiohq/web-theme";

export const DraggableItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  margin-bottom: 8px;
  background: ${props => props.theme.colors.neutral10};
  border: 1px solid ${props => props.theme.colors.neutral30};
  border-radius: 6px;
  cursor: default;

  &:hover {
    border-color: ${props => props.theme.getColor("gray", 200)};
  }
`;

export const DragHandle = styled.div<{ isDisabled?: boolean }>`
  cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "grab")};
  font-size: 18px;
  color: ${props => props.theme.getColor("gray", 400)};
  padding-top: 2px;
  user-select: none;

  &:active {
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "grabbing")};
  }
`;

export const ItemFields = styled.div`
  flex: 1;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${props => props.theme.getColor("gray", 400)};
  font-size: 16px;
  padding: 4px 8px;
  border-radius: 4px;
  flex-shrink: 0;
  margin-top: 4px;

  &:hover {
    color: ${props => props.theme.getColor("red", 800)};
    background: ${props => props.theme.getColor("red", 0)};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
